export const createServicesSlice = (set, get) => ({
    // Selected services
  selectedServices: [],
  setSelectedServices: (services) => set({ selectedServices: services }),
  addService: (service) =>
    set((state) => ({
      selectedServices: [...state.selectedServices, service]
    })),
  removeService: (serviceId) =>
    set((state) => ({
      selectedServices: state.selectedServices.filter(
        (s) => s.id !== serviceId
      )
    })),
  clearServices: () => set({ selectedServices: [] }),
})
